import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpHoverTooltipComponent from './adpHoverTooltip.component';

let adpHoverTooltipModule = angular.module('adpHoverTooltip', [
  uiRouter
])

.component('adpHoverTooltip', adpHoverTooltipComponent)

.name;

export default adpHoverTooltipModule;



// WEBPACK FOOTER //
// ./src/app/components/adpHoverTooltip/adpHoverTooltip.js